import { Injectable } from '@angular/core';
import { acknowledgementApi } from 'src/app/config';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AcknowledgementService {

  constructor(private apiService: ApiService) { }

  getAcknowledgements(role: string): any {
    return this.apiService.get(`${acknowledgementApi.getAcknowledgements}${role}`);
  }

  captureUserAcknowledgement(req: any): any {
    return this.apiService.post(acknowledgementApi.captureUserAcknowledgement, req);
  }

}
